import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=e5639b48&scoped=true"
import script from "./preview-video.vue?vue&type=script&lang=js"
export * from "./preview-video.vue?vue&type=script&lang=js"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=e5639b48&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5639b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5639b48')) {
      api.createRecord('e5639b48', component.options)
    } else {
      api.reload('e5639b48', component.options)
    }
    module.hot.accept("./preview-video.vue?vue&type=template&id=e5639b48&scoped=true", function () {
      api.rerender('e5639b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/preview-video.vue"
export default component.exports